<template>
  <div id="offers-banner" class="postulate-success">
    <section class="banner">
      <v-parallax height="990" src="@/assets/images/banner.webp">
        <v-container class="my-10">
          <v-row justify="center" align="center">
            <!-- Central card -->
            <v-col cols="12" sm="12" lg="6" class="px-md-5">
              <v-card
                min-height="450"
                elevation="10"
                rounded="xl"
                class="postulate-success__card postulate-success__card--center"
              >
                <v-col cols="12" class="postulate-success__title">
                  ¡Listo!
                </v-col>
                <v-col cols="12">
                  <v-img src="@/assets/images/check.webp" width="90" contain  class="mx-auto my-0 pa-0"></v-img>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-row justify="center" align-content="center">
                    <v-col cols="10" class="postulate-success__text" >
                      <p class="postulate-success__text">
                        Muchas gracias por postular aquí
                      </p>
                      <p class="postulate-success__text">
                        <span class="font-organization">{{ coNames }} </span>
                        <span class="font-offer-title">{{ title }}</span>
                      </p>
                      <p class="postulate-success__text">
                        Ahora la organización ya tiene acceso a tu 
                        postulación para contactarte cuando sea necesario.
                        Mantente atento/a.
                      </p>
                      <p class="postulate-success__text postulate-success__text--bold">
                        ¡ÉXITO CON ESE MATCH!
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>

            <!-- Side card - Go to offers -->
            <v-col cols="6" lg="3"  class="px-md-5 my-6 order-lg-first">
              <v-card
                min-height="450"
                max-height="450"
                elevation="10"
                rounded="xl"
                class="d-flex flex-column justify-center align-center"
              >
                <v-col cols="12" class="d-flex justify-center">
                  <v-img src="@/assets/images/explorar.webp" contain max-width="150" ></v-img>
                </v-col>
                <v-col cols="12" class="msg-tanks my-10 text-center">
                  <p class="mb-0">Sigue explorando</p>
                  <p class="mb-0">otras ofertas</p>
                  <p class="mb-0">con sentido</p>
                </v-col>
                <v-col cols="12" class="d-flex justify-center align-end px-5">
                  <v-btn dark color="#3dadff" :to="{name: 'Home'}" block>VER OFERTAS</v-btn>
                </v-col>
              </v-card>
            </v-col>

            <!-- Side card - go to profile -->
            <v-col cols="6" lg="3" class="px-md-5 my-6">
              <v-card min-height="450" max-height="450" elevation="10" rounded="xl" class="d-flex flex-column justify-center align-center">
                <v-col cols="12" class="d-flex justify-center">
                  <v-img src="@/assets/images/proceso.webp" contain max-width="150" ></v-img>
                </v-col>
                <v-col cols="12" class="msg-tanks my-10 text-center">
                  <p class="mb-0">Revisa las etapas</p>
                  <p class="mb-0">del proceso</p>
                  <p class="mb-0">en tu perfil</p>
                </v-col>
                <v-col cols="12" class="d-flex justify-end align-end px-5">
                  <v-btn dark color="#3dadff" block to="/candidate/home">IR AL PERFIL</v-btn>
                </v-col>
              </v-card>
            </v-col>




          </v-row>
        </v-container>
      </v-parallax>
    </section>
  </div>
</template>

<script>
import { meta } from "../libs/mixins";

export default {
    name: "PostulateSuccess",

    props: ["slug", "coNames", "title"],

    mixins: [meta],
    
    metaInfo() {
        return this.getMetaInfo({
            title: "Postulación exitosa",
        });
    },
};
</script>
